// Topbar.jsx
import React from "react";

export default function Topbar({ onToggleSidebar, collapsed }) {
  return (
    <div className={`topbar ${collapsed ? "collapsed" : ""}`}>
      <div className="left-section">
        <button className="toggle-btn" onClick={onToggleSidebar}>
          ☰
        </button>
        <div className="topbar-logo">P</div>
        <span className="company-name">PowerBI Dashboards</span>
      </div>

      <button className="logout-btn" onClick={() => {
        localStorage.removeItem("user");
        window.location.href = "/login";
      }}>
        Logout
      </button>
    </div>
  );
}
